module.exports = __webpack_public_path__ + "img/ic_non_white.846d60e2.svg";